
import React, { useState, useEffect } from 'react';
import { Badge as BadgeType } from '@/utils/gamification';
import { Confetti } from './Animations';
import { getConfettiColors } from '@/utils/gamification';

interface BadgeAlertProps {
  badge: BadgeType;
  onClose: () => void;
}

const BadgeAlert: React.FC<BadgeAlertProps> = ({ badge, onClose }) => {
  const [show, setShow] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      setTimeout(onClose, 500); // Give time for exit animation
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [onClose]);
  
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <Confetti colors={getConfettiColors(10)} pieces={50} duration={4000} />
      
      <div 
        className={`bg-white/90 backdrop-blur-md rounded-2xl border border-hormony-coral/20 shadow-xl p-6 max-w-xs w-full 
        pointer-events-auto transition-all duration-500 transform ${show ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}
      >
        <div className="flex flex-col items-center">
          <div className="w-20 h-20 rounded-full mb-4 flex items-center justify-center"
            style={{ 
              background: badge.gradient || badge.backgroundColor
            }}
          >
            <span className="text-4xl">{badge.icon}</span>
          </div>
          
          <h3 className="text-xl font-semibold text-hormony-charcoal mb-1">Badge Unlocked!</h3>
          <h4 className="text-lg font-medium text-hormony-coral mb-2">{badge.name}</h4>
          
          <p className="text-center text-hormony-charcoal/70 text-sm mb-4">
            {badge.description}
          </p>
          
          <button 
            className="bg-hormony-coral text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-hormony-dark-coral transition-colors"
            onClick={onClose}
          >
            Awesome!
          </button>
        </div>
      </div>
    </div>
  );
};

export default BadgeAlert;
